export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11278_BY_PERSON':                 'By Person',
    '_11279_BY_ACTION':                 'By Action',
    '_11280_TILE_VIEW':                 'Tile View',
    '_11281_GRID_VIEW':                 'Grid View',
    '_11282_SEARCH':                    'Search',
    '_11283_COACHING_REQUIRED':         'New Plan Required',
    '_11284_REVIEW_ACTIVE_COACHING':    'Needs Attention',
    '_11285_SUCCESSFUL_COACHING':       'Coaching - Winning',
    '_11286_ON_TRACK':                  'On Track',
    '_11287_TEAM':                      'Team',
    '_11288_OA':                        'OA',
    '_11289_WIN_PCT':                   'Win %',
    '_11290_PERSONA':                   'Category',
    '_11291_NEXT_BEST_ACTION':          'Next Best Action',
    '_11292_ACTIONS':                   'Actions',
    '_11293_FOLLOW_UP':                 'Follow-Up',
    '_11294_COACH':                     'Start New',
    '_11295_UPDATE':                    'Extend Expiry',
    '_11296_CELEBRATE':                 'Celebrate',
    '_11297_OBSERVE':                   'Observe',
    '_11298_SELECT_A_COMMITMENT':       'Select a commitment',
    '_11299_SELECT_AN_OPPORTUNITY':     'Select an opportunity',
    '_11300_GAME_PLAN':                 'Game Plan',
    '_11301_PEOPLE':                    'people',
    '_11302_ACTIONS_META':              'actions',
    '_11303_RESULTS':                   'results',
    '_11304_SEARCH_PERFORMERS':         'Search performers',
    '_11305_TAGLINE_NEEDS_COACHING':    'OA opportunities available',
    '_11306_TAGLINE_COACHING_REVIEW':   'Plan requires update or review',
    '_11307_TAGLINE_SUCCESSFUL':        'All plans are winning',
    '_11308_TAGLINE_ON_TRACK':          'Meeting all objectives',
    '_11309_OTHER_ACTIONS':             'Other Actions',
    '_11310_NO_PERFORMERS':             'No performers in this category',
    '_11311_NO_ACTIONS_LANE':           'No actions',
    '_11312_NO_ACTIONS_TAG':            'No Actions',
    '_11313_OA_NO_DATA':                'OA: No data',
    '_11314_OA_ON_TARGET':              'OA: On target',
    '_11315_OA_BELOW_TARGET':           'OA: Below target',
    '_11316_OA_ZERO':                   'OA: Zero',
    '_11317_CLOSE':                     'Close',
    '_11318_CANCEL':                    'Cancel',
    '_11319_ACTUAL':                    'Actual',
    '_11320_TARGET':                    'Target',
    '_11321_PCT_TO_TARGET':             '% to Target',
    '_11322_30_DAY_FORECAST':           '30 Day Forecast',
    '_11323_GOAL':                      'Goal',
    '_11324_PCT_TO_GOAL':               '% to Goal',
    '_11325_EXPIRY':                    'Expiry',
    '_11326_LEGEND':                    'Legend',
    '_11327_PERSONAS':                  'Categories',
    '_11328_DESC_NEEDS_COACHING':       'Performer has not been coached on the expected number of opportunities and additional OA opportunities are available.',
    '_11329_DESC_COACHING_REVIEW':      'Performer has a plan that is declining or an expired goal',
    '_11330_DESC_SUCCESSFUL_COACHING':  'All active plans for performer are winning since coaching began',
    '_11331_DESC_ON_TRACK':             'Performer is meeting expectations on all opportunity KPIs and has no active goal coaching',
    '_11332_DESC_FOLLOW_UP':            'There are commitment(s) that are pending sign-off for this performer.',
    '_11333_DESC_COACH':                'Performer has OA opportunities that require coaching. Open a coaching detail and start a coaching conversation.',
    '_11334_DESC_UPDATE':               'Performer has commitments with goals that are either expired or about to expire. Review and update the goals for those commitments.',
    '_11335_DESC_CELEBRATE':            'Performer has an achievement to recognize. Congratulate the performer.',
    '_11336_DESC_OBSERVE':              'Performer has an active commitment that has not been recently observed. Complete a scheduled observation.',
    '_11341_REVIEW':                    'Review',
    '_11342_DESC_REVIEW':               'Performer has active coaching plans that are not improving. Review the performer\'s statistics.',
    '__IMPROVING_COACHING':             'Coaching - Improving',
    '__TAGLINE_IMPROVING':              'Active plan - improving',
    '__DESC_IMPROVING':                 'Performer has at least one plan that is marked as Improving in Winning Percent',
    '__COACHING_RAMP':                  'Coaching - Ramp',
    '__TAGLINE_COACHING_RAMP':          'New Plans',
    '__DESC_COACHING_RAMP':             'Performer has a brand new plan that is not yet being scored in winning %',
    '__FILTER':                         'Filter',
    '__FILTER_BY_CATEGORY':             'Filter by category',
    '__CLEAR':                          'Clear',
    '__TOOLTIP_FOLLOW_UP':              'Gain approval on commitment with pending changes',
    '__TOOLTIP_COACH':                  'Start a new coaching plan',
    '__TOOLTIP_UPDATE':                 'Update goal before it expires',
    '__TOOLTIP_CELEBRATE':              'Visit Event Centre to recognize performer\'s achievement',
    '__TOOLTIP_OBSERVE':                'Complete an observation for the performer\'s active commitment.',
    '__TOOLTIP_REVIEW':                 'Investigate why the performer\'s plan is declining',
    '__WP_WIN':                         'WP: Winning',
    '__WP_IMPROVE':                     'WP: Improving',
    '__WP_DECLINE':                     'WP: Declining',
    '__WP_NEW':                         'WP: New',
    '__WP_NO_DATA':                     'WP: No data',
    '__APPROVE':                        'Approve',
    '__UPDATE_GOAL':                    'Update Goal',
    '__UPDATE_EXPIRED':                 'Update Expired',
    '__ASSESS_PROFICIENCY':             'Assess Proficiency',
    '__START_DEV_PLAN':                 'Start Dev Plan',
    '__CHECK_IN':                       'Check-In',
    '__CLOSE_OLD':                      'Close Old',
    '__CLOSE_NEW_MANAGER':              'Close - New Manager',
    '__COMPLETE':                       'Complete',
    '__RESOLVE':                        'Resolve',
    '__DESC_APPROVE':                   'Commitment is pending awaiting your approval',
    '__DESC_UPDATE_GOAL':               'Goal has been successfully achieved, increase the goal to move towards target',
    '__DESC_UPDATE_EXPIRED':            'Performer has commitments with expired goals. Update expiry to refresh coaching plan.',
    '__DESC_ASSESS_PROFICIENCY':        'Performer has commitments that have not been recently assessed for proficiency',
    '__DESC_START_DEV_PLAN':            'Performer does not have any active coaching plans and is an eligible target for a development plan',
    '__DESC_CHECK_IN':                  'Performer has commitments that have not been recently updated',
    '__DESC_CLOSE_OLD':                 'Performer has commitments that have been open past being eligible for OA scoring',
    '__DESC_CLOSE_NEW_MANAGER':         'Performer has commitments from when they reported to a previous manager',
    '__DESC_COMPLETE':                  'Performer has commitments that have met target and can be successfully completed',
    '__DESC_RESOLVE':                   'Performer has commitments that are currently disputed',
    '__TOOLTIP_APPROVE':                'Approve pending changes',
    '__TOOLTIP_UPDATE_GOAL':            'Increase goal value',
    '__TOOLTIP_UPDATE_EXPIRED':         'Update expiry to a future date',
    '__TOOLTIP_ASSESS_PROFICIENCY':     'Score proficiency on observation',
    '__TOOLTIP_START_DEV_PLAN':         'Start a development plan',
    '__TOOLTIP_CHECK_IN':               'Update commitment',
    '__TOOLTIP_CLOSE_OLD':              'Close commitment',
    '__TOOLTIP_CLOSE_NEW_MANAGER':      'Close commitment',
    '__TOOLTIP_COMPLETE':               'Close successful commitment',
    '__TOOLTIP_RESOLVE':                'Resolve commitment disputes'
};
